import logisticsApi from "./logisticsApi";
import { DealerUsersProps } from "store/modules/DealerUsers/types.store";
import { userProfile } from "enums/options/users";
import type {
  GetDealerDriversParams,
  LogisticsDealerDriverDto,
  LogisticsDealerDriversResponseDto,
} from "types/dealerDriver";

const DEFAULT_DRIVERS_LIMIT = 200;
const inflightDriverRequests = new Map<string, Promise<DealerUsersProps[]>>();
const EMPTY_CELLPHONE = {
  number: "",
  areaCode: "",
  countryCode: "",
};

function buildDriversQuery(
  limit: number,
  keyset?: string,
  statuses?: string[],
): string {
  const params = new URLSearchParams();
  params.append("limit", String(limit));
  if (keyset) {
    params.append("keyset", keyset);
  }
  statuses?.forEach((status) => {
    params.append("statuses", status);
  });
  return `?${params.toString()}`;
}

export function mapLogisticsDriverToDealerUser(
  driver: LogisticsDealerDriverDto,
): DealerUsersProps {
  return {
    id: driver.id,
    dealerId: driver.dealer?.id ?? "",
    name: driver.name,
    surname: "",
    email: "",
    profile: userProfile.DELIVERYMAN,
    cellphone: EMPTY_CELLPHONE,
    status: driver.status,
    enabled: driver.enabled,
  };
}

export async function getDealerDrivers({
  dealerId,
  limit = DEFAULT_DRIVERS_LIMIT,
  keyset,
  statuses,
}: GetDealerDriversParams): Promise<DealerUsersProps[]> {
  if (!dealerId) {
    return [];
  }

  const statusesKey = statuses?.join(",") ?? "";
  const requestKey = `${dealerId}:${limit}:${keyset ?? ""}:${statusesKey}`;
  const inflightRequest = inflightDriverRequests.get(requestKey);
  if (inflightRequest) {
    return inflightRequest;
  }

  const request = logisticsApi
    .get<LogisticsDealerDriversResponseDto>(
      `/v1/dealers/${dealerId}/drivers${buildDriversQuery(
        limit,
        keyset,
        statuses,
      )}`,
    )
    .then(({ data }) => (data?.data ?? []).map(mapLogisticsDriverToDealerUser))
    .finally(() => {
      if (inflightDriverRequests.get(requestKey) === request) {
        inflightDriverRequests.delete(requestKey);
      }
    });

  inflightDriverRequests.set(requestKey, request);
  return request;
}
